'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002415 from "./presto.-Agent-View$$anon$15.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dSign$002dRequest$0024 from "./presto.-Agent-View$-Local-Shodo-Sign-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$14() {
  this.awS = null;
  this.awK = null;
  this.awL = false;
  this.awT = null;
  this.awU = false;
  this.awX = null;
  this.awQ = null;
  this.awR = false;
  this.awM = null;
  this.awN = false;
  this.awO = null;
  this.awP = false;
  this.awV = false;
  this.awW = false;
  this.awS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.awX = "LocalShodoSignRequest";
}
export { $c_Lpresto_AgentView$$anon$14 as $c_Lpresto_AgentView$$anon$14 };
$p = $c_Lpresto_AgentView$$anon$14.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$14;
/** @constructor */
function $h_Lpresto_AgentView$$anon$14() {
}
export { $h_Lpresto_AgentView$$anon$14 as $h_Lpresto_AgentView$$anon$14 };
$h_Lpresto_AgentView$$anon$14.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.awS;
});
$p.M = (function() {
  if ((!this.awL)) {
    this.awK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.awL = true;
  }
  return this.awK;
});
$p.O = (function() {
  if ((!this.awU)) {
    this.awT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.awU = true;
  }
  return this.awT;
});
$p.D = (function() {
  return this.awX;
});
$p.t = (function() {
  if ((!this.awR)) {
    this.awQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("nomeAlgoritmo", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("textos", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.awR = true;
  }
  return this.awQ;
});
$p.N = (function() {
  if ((!this.awN)) {
    this.awM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fi(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.awN = true;
  }
  return this.awM;
});
$p.Q = (function() {
  if ((!this.awP)) {
    this.awO = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002415.$c_Lpresto_AgentView$$anon$15();
    this.awP = true;
  }
  return this.awO;
});
$p.v = (function() {
  if ((!this.awW)) {
    this.awV = false;
    this.awW = true;
  }
  return this.awV;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee100) => ((p) => \u03b4scrutinee100.cGT(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dSign$002dRequest$0024.$m_Lpresto_AgentView$LocalShodoSignRequest$())));
});
var $d_Lpresto_AgentView$$anon$14 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$14, "presto.AgentView$$anon$14", ({
  DI: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$14 as $d_Lpresto_AgentView$$anon$14 };
//# sourceMappingURL=presto.-Agent-View$$anon$14.js.map
